import React, { useState, useMemo, useRef, useEffect, useImperativeHandle } from 'react';
import { Modal, Input, Button, Dropdown, notification, Form, Radio, Select, Switch } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { addTrueDataFeedback, editTrueDataFeedback, onceIdentification } from '@/pages/intelligence/services/topcharts';
import FormGameSelector from '@intelligence/components/FormGameSelector';
import AISVG from '@home/assets/img/AI.svg';
import {
  METRICLISTOPTIONSCOMBINE,
  METRICLISTOPTIONSMOBILE,
  // FEEDBACKSOURCEOPTIONS,
} from './utils/config';
import { toDateTypeLy, toDateTypeFilter } from '@/pages/intelligence/utils/common';
import './index.scss';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import RangePicker from '@/pages/home/components/RangePicker';
import ImagesUploaderCustomm from './components/ImagesUploaderCustomm';
import { IImagesUploaderInstance, IUploadSuccessPayload } from '@/pages/home/components/ImagesUploader/types';
import { useMemoizedFn, useGetState, useDeepCompareEffect } from 'ahooks';
import moment from 'moment';
import { isValidDate } from '@intelligence/utils/filterUtils';
import { componentDefault } from '@intelligence/components/Filter/FilterBase/FilterList';
import { history } from 'umi';
import classnames from 'classnames';
import AIIMAGE from '@/pages/home/assets/img/AIIMAGE.svg';
import { searchAllGames } from '@/pages/intelligence/services/filter';
import Loading from '@/pages/datalab/components/Loading';
import Feedback from '@home/components/NavHeader/components/Feedback';
import DataIssue from '@intelligence/assets/svg/gameInfo/DataIssue.svg';
import TrueData from '@intelligence/assets/svg/gameInfo/TrueData.svg';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import { isArray } from 'lodash';
import { dbiBtnLogMes } from '@intelligence/utils/buriedPointCfg';

const { TextArea } = Input;
const MODAL_SIZE_LARGE = 800;
const ONCE = 'once';
const TIME = 'time';
const LINKEXPRESSION = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
// const LINKEXPRESSION = /https?:\/\/(?:www\.)?[^\s/$.?#].[^\s]*/g;

/**
 * 真实上传组件 按钮打点配置
 */
export interface IPublicTrueDataBtnLogConfig {
  /**
   * 按钮打点配置，默认值为情报的按钮打点配置
   */
  btnLogKeyMap?: IRecord;
  /**
   * 真数上传按钮打点配置的key
   */
  publicTrueDataReportBtnLogKey?: string;
}

export interface IPublicTrueDataInstance {
  /**
   * 打开新增真数反馈的弹窗
   */
  open: () => void;
}

interface IPublicTrueDataProps extends IBaseProps, IPublicTrueDataBtnLogConfig {}

const PublicTrueData: React.ForwardRefRenderFunction<IPublicTrueDataInstance, IPublicTrueDataProps> = (props, ref) => {
  const {
    entityType,
    gameId,
    gameData,
    handleSubmitSuccessFun, // 接口外部传入方法，新增反馈成功后调用
    isNeedSearchGame = false,
    fetchTrueDataFeedbackHistory,
    pageId,
    setGameIdValue,
    setGameData,
    setEntityTypeValue,
    // buttonKey = 'i_want_to_contribute',
    isEdit = false, // 是否是编辑状态
    editRecord = {},
    isOutsideOpen = false,
    outsideFeedBackVisible = false,
    setOutsideFeedBackVisible,
    selectGameName,
    setSelectGameName,
    feedBackParams, // 宽表参数
    buttonNoShow, // true 不显示  默认显示 按钮不显示
    setAllDataModel,
    isGameDetail = false,
    match,
    activeId,
    btnLogKeyMap = dbiBtnLogMes,
    publicTrueDataReportBtnLogKey = '',
  } = props;

  // @ts-ignore
  const btnPointConfig = btnLogKeyMap?.[publicTrueDataReportBtnLogKey];

  // console.log('feedbackInfo-props', props);
  const { formatMessage, locale } = useIntlExtend();
  const [modalVisible, setModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [onceValue, setOnceValue] = useState('');

  const [imagesData, setImagesData, getImagesData] = useGetState < IUploadSuccessPayload > ({
    success: [],
    error: [],
  });
  const [entityTypeBoth, setEntityTypeBoth] = useState(entityType);
  const [isShowCustomize, setIsShowCustomize] = useState(false);
  const [isOpenCustomize, setIsOpenCustomize] = useState(false);
  const [metricName, setMetricName] = useState('Lifetime Revenue');
  const [metricValue, setMetricValue] = useState('');
  const [dateValue, setDateValue] = useState(componentDefault.month);
  const [dateTypeValue, setDateTypeValue] = useState('month');
  const [dateRadio, setDateRadio] = useState(TIME);
  const [customizeMetricValue, setCustomizeMetricValue] = useState('');
  const [customizeMetric, setCustomizeMetric] = useState('');
  const [linkValue, setLinkValue] = useState('');
  const [noteValue, setNoteValue] = useState('');
  const [sourceValue, setSourceValue] = useState('Public Data');
  const [editImagesData, setEditImagesData] = useState([]);
  const [recordId, setRecordId] = useState(0);
  const [cdnImageSrcList, setCdnImageSrcList] = useState([]);
  const metricOptions = entityType === 'mobile' ? METRICLISTOPTIONSMOBILE : METRICLISTOPTIONSCOMBINE;
  const [isFirstStats, setIsFirstStats] = useState(true);
  const [anonymity, setAnonymity] = useState(editRecord.anonymity || false);

  const [aiLoading, setAiLoading] = useState(false);
  const [gameIdLoading, setGameIdLoading] = useState(false);
  const [identificationText, setIdentificationText] = useState('');
  const [addType, setAddType] = useState('');

  const [isFocused, setIsFocused] = useState(false);

  const [identificationCur, setIdentificationCur] = useState('');
  const [identificationCurInfo, setIdentificationCurInfo] = useState('dbh_AI_error_tips');

  // ImagesUploader组件实例
  const uploaderInstance = useRef < IImagesUploaderInstance > (null);

  const FEEDBACKSOURCEOPTIONS = [
    {
      text: formatMessage({ id: 'dbi_feedback_public_data' }),
      value: 'Public Data',
    },
    {
      text: formatMessage({ id: 'dbi_feedback_expert_knowledge' }),
      value: 'Expert Knowledge',
    },
    // {
    //   text: formatMessage({ id: 'dbi_feedback_financial_reports' }),
    //   value: 'Financial Reports',
    // },
    // {
    //   text: formatMessage({ id: 'dbi_feedback_public_others' }),
    //   value: 'Others',
    // },
  ];

  // 编辑初始化
  useDeepCompareEffect(() => {
    // console.log('editRecordeditRecord', editRecord);
    if (isEdit) {
      setNoteValue(editRecord.content || '');
      setMetricValue(editRecord.metric_value || '');
      // 回显自定义指标
      setMetricOptionsFun(editRecord.metric_name);
      setMetricName(editRecord.metric_name || '');
      if (editRecord.metric_start_date === ONCE) {
        setDateRadio(ONCE);
        setDateValue(['', '']);
        setOnceValue(editRecord.metric_end_date);
      } else if (editRecord.metric_start_date !== '') {
        setDateRadio(TIME);
        setDateValue([moment(editRecord.metric_start_date), moment(editRecord.metric_end_date)]);
        setDateTypeValue(toDateTypeFilter[editRecord.granularity || 'month']);
      } else {
        setDateRadio(TIME);
        setDateValue(componentDefault.month);
        setDateTypeValue('month');
      }

      setSourceValue(editRecord.source_type || 'Public Data');
      setLinkValue(editRecord.url || '');
      setEditImagesData(editRecord.signature_source_image ? editRecord.signature_source_image?.split('|') : []);
      setCdnImageSrcList(
        editRecord.source_image
          ? !isArray(editRecord.source_image)
            ? editRecord.source_image?.split('|')
            : editRecord.source_image
          : [],
      );
      setRecordId(Number(editRecord.id || 0));
    }
    // setGameIdValue(gameId);
  }, [editRecord, isEdit]);

  const setItemGameInfo = (gameId?: any, gameData?: any) => {
    setGameIdValue(gameId);
    gameData && setGameData(gameData);
    if (gameData) {
      const combined_id = gameData?.typeIdList?.filter((item: any) => item.type === 'combine')[0]?.id || '';
      const mobile_id = gameData?.typeIdList?.filter((item: any) => item.type === 'mobile')[0]?.id || '';
      const console_id = gameData?.typeIdList?.filter((item: any) => item.type === 'console')[0]?.id || '';
      const pc_id = gameData?.typeIdList?.filter((item: any) => item.type === 'pc')[0]?.id || '';
      const gameTypeData = [
        { value: 'mobile', text: formatMessage({ id: 'dbi_mobile_games' }), disabled: !mobile_id },
        {
          value: 'combine',
          text: formatMessage({ id: 'dbi_pcconsole_games' }),
          disabled: !(combined_id && (console_id || pc_id)),
        },
        {
          value: 'Both',
          text: formatMessage({ id: 'dbi_mobile_games_pc' }),
          disabled: !(combined_id && (console_id || pc_id) && mobile_id),
        },
      ];
      setGameTypeList(gameTypeData);
      if (mobile_id && !console_id && !pc_id) {
        setEntityTypeBoth('mobile');
        setEntityTypeValue('mobile');
        setGameIdValue(mobile_id);
      }
      if ((pc_id || console_id) && combined_id) {
        setEntityTypeBoth('combine');
        setEntityTypeValue('combine');
        setGameIdValue(combined_id);
      }
      if (mobile_id && combined_id && (pc_id || console_id)) {
        setEntityTypeBoth('Both');
        setGameIdValue(combined_id);
      }
    }
  };

  // 编辑状态下，删除原有图片
  const handleDeleteEditImage = (imageSrc: string) => {
    const imageListTemp = [...editImagesData];
    const imageListValue = imageListTemp?.filter((item) => item !== imageSrc);
    setEditImagesData(imageListValue);
  };

  const handleToggleModal = (type?: any) => {
    setIsOpenCustomize(false);
    setIsFirstStats(true);
    setIdentificationText('');
    if (isOutsideOpen) {
      setOutsideFeedBackVisible?.(!outsideFeedBackVisible);
    } else {
      setModalVisible(!modalVisible);
    }
    if (addType === 'detail_add') {
      setDateRadio(TIME);
      setDateValue(componentDefault.month);
      setDateTypeValue('month');
      setOnceValue('');
      setCustomizeMetricValue('');
      setMetricName('Lifetime Revenue');
      setMetricValue('');
      setAnonymity(false);
      setSourceValue('Public Data');
      setLinkValue('');
      setImagesData({ success: [], error: [] });
      setNoteValue('');
      return;
    }
    if (!type && !isEdit) {
      initParams();
      return;
    }
  };

  const uploadImageErrorMsg = formatMessage({
    id: 'dbh_feedback_upload_img_error_msg',
    defaultMessage: 'Upload failed, please upload again',
  });

  const handleInputChange = (val: string) => {
    setCustomizeMetricValue(val);
  };

  const handleInputDataChange = (val: string) => {
    setMetricValue(val);
  };

  const handleInputLinkChange = (val: string) => {
    setLinkValue(val);
  };

  const handleCustomize = () => {
    setIsShowCustomize(true);
    setIsOpenCustomize(true);
  };

  const setMetricOptionsFun = (metricValue: string) => {
    if (metricValue && metricValue !== '') {
      const metricValueTemp = metricOptions?.find((item: any) => item.value === metricValue);
      if (!metricValueTemp) {
        setCustomizeMetric(metricValue);
      }
    }
  };

  const handleCustomizeConfirm = () => {
    setCustomizeMetric(customizeMetricValue);
    setMetricName(customizeMetricValue);
    setIsShowCustomize(false);
    setIsOpenCustomize(false);
  };

  const handleCustomizeCancel = () => {
    setIsShowCustomize(false);
    setIsOpenCustomize(false);
    setCustomizeMetricValue('');
  };

  const handleDatePickerChange = (dateValue: any, dateType: string) => {
    let dateValueTemp = ['', ''];
    if (Array.isArray(dateValue) && dateValue.length === 2) {
      const startDate = dateValue[0];
      let endDate = dateValue[1];
      /** 切换左侧日周月时，因为默认值为空，所以这里默认值给切换的值 */
      if (!startDate && !endDate) {
        dateValueTemp = componentDefault[dateType];
      } else {
        if (dateType === 'month') {
          // 月粒度为 1-31号的格式
          endDate = moment(endDate).endOf('month');
        }

        dateValueTemp = [startDate, endDate];
      }
    }

    setDateValue(dateValueTemp);
    setDateTypeValue(dateType);
  };

  // 获取图片存在COS的path列表
  const getImagesPaths = useMemoizedFn(() => {
    const images = imagesData?.success || [];
    return images?.map((image) => image?.path)?.filter((path) => !!path);
  });

  // 获取编辑图片，在cdn上的地址值
  const getCDNImageSrc = (editImagesData: string[], cdnImageSrcList: string[]) => {
    const imgSrcList: any = [];
    editImagesData?.forEach((itemPaSrc) => {
      const srcValue = cdnImageSrcList?.find((srcItem) => itemPaSrc?.includes(srcItem));
      if (srcValue) {
        imgSrcList.push(srcValue);
      }
    });
    return imgSrcList;
  };
  const showAllTrueModal = () => {
    setAllDataModel(true);
  };
  // 提交Feedback
  const submitFeedback = useMemoizedFn(async () => {
    setIsFirstStats(false);
    const imagesPaths = getImagesPaths();
    const startDateTemp = Array.isArray(dateValue) && dateValue?.length > 1 ? dateValue[0] : '';
    const endDateTemp = Array.isArray(dateValue) && dateValue?.length > 1 ? dateValue[1] : '';
    const startDate = isValidDate(startDateTemp) ? moment(startDateTemp).format('YYYY-MM-DD') : '';
    const endDate = isValidDate(endDateTemp) ? moment(endDateTemp).format('YYYY-MM-DD') : '';
    const isTime = dateRadio === TIME;
    const startDateValue = isTime ? startDate : ONCE;
    const endDateValue = isTime ? endDate : onceValue;
    // 若有编辑图片
    const imglist = [...getCDNImageSrc(editImagesData, cdnImageSrcList), ...imagesPaths];
    const sourceimageValue = isEdit ? imglist?.join('|') : imagesPaths?.join('|');

    const gameIdStats = !!(gameId && gameId !== '');
    const dataStats = !!(metricValue && metricValue !== '');
    const metricStats = !!(metricName && metricName !== '');
    const dateStats = !!(startDateValue && startDateValue !== '');
    const sourceStats = !!(sourceValue && sourceValue !== '');

    if (gameIdStats && dataStats && metricStats && dateStats && sourceStats) {
      const params = {
        content: noteValue,
        entity_type: entityType,
        game_id: gameId,
        metric_name: metricName,
        metric_start_date: startDateValue,
        metric_end_date: endDateValue,
        metric_value: metricValue,
        source_type: sourceValue,
        source_image: sourceimageValue,
        url: linkValue,
        page_id: pageId,
        granularity: toDateTypeLy[dateTypeValue],
      } as any;
      if (entityTypeBoth === 'Both') {
        params.game_list = [];
        const list = ['combine', 'mobile'];
        const otherType = list.filter((item: any) => item !== entityType);
        gameData?.typeIdList?.map((type: any) => {
          if (type?.type === otherType[0] && type?.id) {
            params.game_list.push({ ...type, game_id: type?.id, entity_type: type?.type });
          }
        });
      }
      if (sourceValue !== 'Public Data') {
        params.anonymity = anonymity;
      }
      setIsLoading(true);
      try {
        // 后端枚举
        const mapType: any = {
          combine: 'pc/console',
          mobile: 'mobile',
          Both: 'pc/console/mobile',
        };
        const res = await (isEdit
          ? editTrueDataFeedback({ ...params, id: recordId })
          : addTrueDataFeedback({ ...params, game_type: mapType[entityTypeBoth] }));
        if (res && res?.code === 0) {
          const paramsTable = {
            entity_type: entityType,
            game_id: gameId,
            page_size: 5,
            ...feedBackParams,
            page_id: '',
            page: 1,
            order_metric: 'fill_time',
            order: 'desc',
          } as any;
          handleSubmitSuccessFun
            ? handleSubmitSuccessFun()
            : !!fetchTrueDataFeedbackHistory &&
              fetchTrueDataFeedbackHistory({ ...paramsTable, entity_type: match?.entityType }, !isEdit);
          if (gameId !== match?.params?.id && isGameDetail) {
            if (entityTypeBoth === 'mobile') {
              window.open(`/intelligence/topCharts/mobileGames/gamesDetails/${gameId}/overview?openTrue=true`, gameId);
            } else if (entityTypeBoth === 'combine') {
              window.open(`/intelligence/topCharts/pcConsoleGames/gamesDetails/${gameId}/overview?openTrue=true`, gameId);
            }
          } else if (activeId && activeId !== 'overview') {
            if (entityTypeBoth === 'mobile') {
              history.push(`/intelligence/topCharts/mobileGames/gamesDetails/${gameId}/overview`);
            } else if (entityTypeBoth === 'combine') {
              history.push(`/intelligence/topCharts/pcConsoleGames/gamesDetails/${gameId}/overview`);
            }
          }
          notification.success({
            unique: true,
            description: setAllDataModel ? (
              <div>
                {formatMessage({
                  // id: 'dbh_feedback_success_tips',
                  id: 'dbi_common_operation_succeed_tips',
                  defaultMessage: 'Feedback success! ',
                })}
                &nbsp;&nbsp;
                <Button type="link" onClick={showAllTrueModal}>
                  {' '}
                  {formatMessage({ id: 'dbh_all_view_true' })}
                </Button>
              </div>
            ) : (
              <div>
                {formatMessage({
                  // id: 'dbh_feedback_success_tips',
                  id: 'dbi_common_operation_succeed_tips',
                  defaultMessage: 'Feedback success!',
                })}
              </div>
            ),
            duration: setAllDataModel ? 2000 : 1000,
          });
        }
      } catch (err) {
        notification.error({
          unique: true,
          description: formatMessage({
            id: 'dbh_feedback_error_tips',
            defaultMessage: 'Feedback Error!',
          }),
          duration: 1000,
        });
      } finally {
        setIsLoading(false);
      }
      handleToggleModal();
      setImagesData({ success: [], error: [] });
    }
  });

  const visibleCur = useMemo(() => {
    if (isOutsideOpen) {
      return outsideFeedBackVisible;
    }
    return modalVisible;
  }, [modalVisible, isOutsideOpen, outsideFeedBackVisible]);

  const gameIdStatsCur = useMemo(() => {
    if (gameId !== '' || isFirstStats) {
      return '';
    }
    return 'error';
  }, [gameId, isFirstStats]);

  const linkStatsCur = useMemo(() => {
    if (sourceValue === 'Expert Knowledge') return '';
    if (LINKEXPRESSION.test(linkValue) || linkValue === '') {
      return '';
    }
    return 'error';
  }, [linkValue, sourceValue]);

  const dataStatsCur = useMemo(() => {
    if (metricValue !== '' || isFirstStats) {
      return '';
    }
    return 'error';
  }, [metricValue, isFirstStats]);

  const sourceStatsCur = useMemo(() => {
    if (sourceValue !== '' || isFirstStats) {
      return '';
    }
    return 'error';
  }, [sourceValue, isFirstStats]);

  const dateStatsCur = useMemo(() => {
    const startDateTemp = Array.isArray(dateValue) && dateValue?.length > 1 ? dateValue[0] : '';
    const startDate = isValidDate(startDateTemp) ? moment(startDateTemp).format('YYYY-MM-DD') : '';
    const isTime = dateRadio === TIME;
    const startDateValue = isTime ? startDate : ONCE;
    if (startDateValue !== '' || isFirstStats) {
      return '';
    }
    return 'error';
  }, [dateValue, dateRadio, isFirstStats]);

  const metricStatsCur = useMemo(() => {
    if (metricName !== '' || isFirstStats) {
      return '';
    }
    return 'error';
  }, [metricName, isFirstStats]);

  const confirmDisabledCur = useMemo(() => {
    if (isFirstStats && linkStatsCur === 'error') return true;
    if (isFirstStats) return false;
    if (
      dataStatsCur === 'error' ||
      metricStatsCur === 'error' ||
      dateStatsCur === 'error' ||
      sourceStatsCur === 'error' ||
      linkStatsCur === 'error' ||
      gameIdStatsCur === 'error'
    ) {
      return true;
    }
    return false;
  }, [gameIdStatsCur, dataStatsCur, metricStatsCur, dateStatsCur, sourceStatsCur, isFirstStats, linkStatsCur]);

  const buttonUI = () => (
    <>
      <div className="select-button">{customizeMetric}</div>
    </>
  );
  const [gameTypeList, setGameTypeList]: any = useState([
    { value: 'mobile', text: formatMessage({ id: 'dbi_mobile_games' }) },
    { value: 'combine', text: formatMessage({ id: 'dbi_pcconsole_games' }) },
    { value: 'Both', text: formatMessage({ id: 'dbi_mobile_games_pc' }) },
  ]);
  const handleOnceClickAI: any = async () => {
    if (!identificationText) return;
    try {
      setAiLoading(true);
      setIdentificationCur('');
      const res = await onceIdentification({ content: identificationText });
      setAiLoading(false);
      setGameIdLoading(true); // ?.status === 'success'
      if (res?.data.result !== 'fail') {
        if (Object.keys(res.data).length === 1 && res?.data?.status === 'fail') {
          setIdentificationCur('error');
          setIdentificationCurInfo('dbh_AI_error_tips');
          return;
        }
        if (Object.keys(res.data).length === 1 && res?.data?.status === 'overlimit') {
          setIdentificationCur('error');
          setIdentificationCurInfo('dbh_AI_error_tips_overlimit');
          return;
        }
        const {
          metric_name,
          custom_date_str,
          true_end_date,
          true_start_date,
          metric_value,
          metric_unit,
          date_type,
          game_name,
          combined_id,
          mobile_id,
          pc_id,
          console_id,
        }: any = res.data;
        // 数据
        if (metric_value || metric_unit) {
          setMetricValue(`${metric_value}${metric_unit}`);
        }
        // 时间
        if (!!custom_date_str) {
          setDateRadio(ONCE);
          setOnceValue(custom_date_str);
          setDateValue(['', '']);
        } else if (true_end_date || true_start_date) {
          const dateType: any = {
            daily: 'date',
            weekly: 'week',
            monthly: 'month',
            yearly: 'year',
          };
          setDateRadio(TIME);
          handleDatePickerChange([moment(true_start_date), moment(true_end_date)], dateType[date_type || 'monthly']);
        } else {
          setDateValue(componentDefault.month);
          setDateTypeValue('month');
        }
        // 指标
        if (metric_name) {
          setMetricName(metric_name);
          setCustomizeMetric(metric_name);
        }
        // 获取游戏信息
        if ((game_name && combined_id) || pc_id || console_id || mobile_id) {
          game_name && setSelectGameName(game_name);
          combined_id &&
            setItemGameInfo(combined_id, {
              id: combined_id,
              name: game_name,
              typeIdList: [
                { id: combined_id, type: 'combine' },
                { id: console_id, type: 'console' },
                { id: pc_id, type: 'pc' },
                { id: mobile_id, type: 'mobile' },
              ],
            });
        }
      } else {
        notification.error({
          unique: true,
          description: formatMessage({
            id: 'dbh_AI_error_tips',
            defaultMessage: formatMessage({ id: 'dbh_AI_error_tips' }),
          }),
          duration: 1000,
        });
      }
      setGameIdLoading(false);
    } catch (error) {
      setAiLoading(false);
      setGameIdLoading(false);
      console.log(error);
    }
  };

  const initParams = () => {
    if (!isGameDetail) {
      setGameIdValue('');
      setSelectGameName('');
      setGameData({});
      setEntityTypeValue('combine');
      setEntityTypeBoth('combine');
    }
    setDateRadio(TIME);
    setDateValue(componentDefault.month);
    setDateTypeValue('month');
    setOnceValue('');
    setCustomizeMetricValue('');
    setCustomizeMetric('');
    setMetricName('Lifetime Revenue');
    setMetricValue('');
    setAnonymity(false);
    setSourceValue('Public Data');
    setLinkValue('');
    setImagesData({ success: [], error: [] });
    setNoteValue('');
  };
  const feedback: any = useRef(null);

  useImperativeHandle(ref, () => ({
    open: () => {
      handleToggleModal();
      setAddType('');
    },
  }));

  return (
    <div className="true-data-feedback-wrap dbi-public-truedata-feedback">
      {!buttonNoShow ? (isNeedSearchGame && !isGameDetail ? (
        <Button
          onClick={() => {
            handleToggleModal();
            setAddType('');
            // 埋点
            if (btnPointConfig) {
              buriedBtnPoint(btnPointConfig);
            }
          }}
          type={'primary'}
        >
          {formatMessage({ id: 'dbh_home_true_data_contribute' })}
        </Button>
      ) : (
        <div className="dbi-feedback-btn-wrap">
          {entityType !== 'console' && entityType !== 'pc' && (
            <Button
              type="primary"
              onClick={() => {
                setAddType('detail_add');
                handleToggleModal('detail_add');
                // 埋点
                if (btnPointConfig) {
                  const extInfo = btnPointConfig.extInfo || '';
                  const extInfoNew = !gameId ? extInfo : `${extInfo}: (${gameId})`;
                  buriedBtnPoint({ ...btnPointConfig, extInfo: extInfoNew });
                }
              }}
              className="dbi-feedback-btn"
            >
              <img src={TrueData} style={{ position: 'relative', top: '2px' }} />
              {/* <SvgIcon type="add-border" className="dbi-feedback-btn-icon" /> */}
              {formatMessage({ id: 'dbi_detail_true_data' })}
            </Button>
          )}
          <Button className="dbi-feedback-btn ns-btn--shadow" onClick={()=> feedback.current?.open()}>
            <img src={DataIssue} />
            {formatMessage({ id: 'dbi_top_data_issue' })}
          </Button>
        </div>
      )) : ''}
      <Feedback ref={feedback} isNoButton={true}></Feedback>

      <Modal
        visible={visibleCur}
        caption={formatMessage({
          id: isEdit ? 'dbi_feedback_edit_public_true_data' : 'dbi_leave_your_feedback',
        })}
        onClose={handleToggleModal}
        className={classnames('dbi-public-truedata-feedback-modal', {
          'dbi-public-truedata-feedback-modal-nosearchgame': !isNeedSearchGame,
        })}
        size={MODAL_SIZE_LARGE}
      >
        <Modal.Body>
          <Form className="dbg-feedback-newbox dbg--ai">
            {isNeedSearchGame && (
              <Form.Item
                className={`dbg--ai-form-item ${isFocused ? '--focus' : ''}`}
                // label={
                //   <div style={{ textAlign: 'center' }}>
                //     <img src={AIIMAGE} alt="" width="40px" />
                //     <div>{formatMessage({ id: 'dbi_identification_label' })}</div>
                //   </div>
                // }
                status={identificationCur}
                message={identificationCur === 'error' ? formatMessage({ id: identificationCurInfo }) : ''}
              >
                <Loading loading={aiLoading}>
                  <TextArea
                    className="unloadModal-input"
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    size="full"
                    placeholder={formatMessage({ id: 'dbi_identification_placeholder' })}
                    maxLength={250}
                    value={identificationText}
                    onChange={(value) => {
                      setIdentificationText(value);
                    }}
                  />

                  <div className="identification-button">
                    <Button
                      className={identificationText ? '' : '--disabled'}
                      type="primary"
                      onClick={handleOnceClickAI}
                      // loading={aiLoading}
                    >
                      {/* <SvgIcon type="robot-new" /> */}
                      <img
                        src={AISVG}
                        alt=""
                        style={{ verticalAlign: 'middle', position: 'relative', top: '-2px', left: '-7px' }}
                      />
                      {formatMessage({ id: 'dbi_identification_auto' })}
                    </Button>
                  </div>
                  {identificationCur === 'error' && (
                    <div className="identification-error-tips">{formatMessage({ id: identificationCurInfo })}</div>
                  )}
                </Loading>
              </Form.Item>
            )}
            {isNeedSearchGame && (
              <Form.Item
                required={true}
                label={formatMessage({ id: 'dbh_metric_game' })}
                status={gameIdStatsCur}
                message={gameIdStatsCur === 'error' ? formatMessage({ id: 'dbi_feedback_game_must_be_in' }) : ''}
              >
                {/* 搜索游戏组件 */}
                <div className="search-select-game">
                  <FormGameSelector
                    entityType={entityType}
                    value={gameId}
                    onConfirm={setItemGameInfo}
                    placeholder={formatMessage({ id: 'dbi_game_placeholder' })}
                    selectGameName={selectGameName}
                    setSelectGameName={setSelectGameName}
                  />
                </div>
              </Form.Item>
            )}
            {isNeedSearchGame && (
              <Form.Item required={true} label={formatMessage({ id: 'dbi_selector_game_type_label' })}>
                {/* 搜索游戏组件 */}
                <div className={'dbi-public-data-group-radio'}>
                  <Radio.Group
                    value={entityTypeBoth}
                    onChange={(value) => {
                      setEntityTypeBoth(value);
                      if (value !== 'Both') {
                        setEntityTypeValue(value);
                      }
                      if(value === 'Both') {
                        gameData.typeIdList?.find((item: any) => item.type === 'combine')?.id && setGameIdValue(gameData.typeIdList?.find((item: any) => item.type === 'combine')?.id)
                      } else {
                        gameData.typeIdList?.find((item: any) => item.type === value)?.id && setGameIdValue(gameData.typeIdList?.find((item: any) => item.type === value)?.id)
                      }
                    }}
                    disabled={gameIdLoading}
                  >
                    {gameTypeList.map((item: any) => {
                      return (
                        <Radio key={item.value} name={item.value} disabled={item.disabled}>
                          {item.text}
                        </Radio>
                      );
                    })}
                  </Radio.Group>
                </div>
              </Form.Item>
            )}

            <Form.Item
              className="dbi-public-truedata-feedback-formitem-date"
              required={true}
              label={formatMessage({ id: 'dbi_date' })}
              status={dateStatsCur}
              message={dateStatsCur === 'error' ? formatMessage({ id: 'dbi_feedback_date_must_be_in' }) : ''}
            >
              <Radio.Group value={dateRadio} onChange={(value) => setDateRadio(value)}>
                <Radio name={TIME}>{formatMessage({ id: 'dbi_feedback_time' })}</Radio>
                <Radio name={ONCE}>{formatMessage({ id: 'dbi_feedback_once' })}</Radio>
                {dateRadio === TIME && (
                  <div className="search-item-date">
                    <RangePicker
                      typeList={['date', 'week', 'month', 'year']}
                      type={dateTypeValue}
                      value={dateValue}
                      className="search-border"
                      language={locale === LANGUAGE_CN ? 'cn' : 'en'}
                      onChange={handleDatePickerChange}
                      syncInput={false} // 输入时间不直接触发onchange
                    />
                  </div>
                )}
                {dateRadio === ONCE && (
                  <Input
                    value={onceValue}
                    style={{ width: '100%' }}
                    placeholder={formatMessage({ id: 'dbi_plc_once' })}
                    onChange={(val) => setOnceValue(val)}
                  />
                )}
              </Radio.Group>
            </Form.Item>

            <Form.Item
              required={true}
              label={formatMessage({ id: 'dbi_top_metric' })}
              status={metricStatsCur}
              message={metricStatsCur === 'error' ? formatMessage({ id: 'dbi_feedback_Metric_must_be_in' }) : ''}
            >

              {isShowCustomize ? (
                <Dropdown
                  escapeWithReference
                  className="dbi-public-truedata-feedback-customize-dropdown"
                  overlayClassName="dbi-public-truedata-feedback-customize-dropdown-overlay"
                  size="m"
                  appearance="button"
                  trigger="click"
                  clickClose={false}
                  open={isOpenCustomize}
                  positionFixed={false}
                  button={metricName}
                  style={{ width: 400 }}
                >
                  <div className="dbi-public-truedata-feedback-customize-dropdown-div">
                    <div className="tea-input-password">
                      <Input
                        value={customizeMetricValue}
                        placeholder={formatMessage({ id: 'dbi_feedback_please_input_the_metric' })}
                        onChange={(val) => handleInputChange(val)}
                      />
                      <div className="tea-input-password__op">
                        <SvgIcon type="clock-tower" className="dbi-feedback-btn-icon" />
                      </div>
                    </div>

                    <div className="dbi-revenue-growth-btn">
                      <Button
                        className="dbi-revenue-growth-left"
                        type="primary"
                        onClick={handleCustomizeConfirm}
                        disabled={customizeMetricValue === ''}
                      >
                        {formatMessage({ id: 'dbi_confirm' })}
                      </Button>
                      <Button className="dbi-revenue-growth-right" onClick={handleCustomizeCancel}>
                        {formatMessage({ id: 'dbi_back' })}
                      </Button>
                    </div>
                  </div>
                </Dropdown>
              ) : (
                <Select
                  appearance="button"
                  matchButtonWidth
                  options={metricOptions}
                  button={customizeMetric !== '' ? buttonUI : undefined}
                  value={metricName}
                  onChange={(value) => {setMetricName(value); setCustomizeMetric('');}}
                  style={{ width: '400px' }}
                  placeholder={formatMessage({ id: 'dbi_feedback_please_select_metric' })}
                  footer={<a onClick={handleCustomize}>{formatMessage({ id: 'dbi_feedback_customize' })}</a>}
                />
              )}
            </Form.Item>
            <Form.Item
              required={true}
              label={formatMessage({ id: 'dbi_data' })}
              status={dataStatsCur}
              message={dataStatsCur === 'error' ? formatMessage({ id: 'dbi_feedback_data_must_be_in' }) : ''}
            >
              <Input
                value={metricValue}
                style={{ width: '100%' }}
                placeholder={formatMessage({ id: 'dbi_feedback_e_g_3m' })}
                onChange={(val) => handleInputDataChange(val)}
              />
            </Form.Item>
            <Form.Item
              // className={'dbi-not-more-padding'}
              required={true}
              label={formatMessage({ id: 'dbi_feedback_source' })}
              status={sourceStatsCur}
              message={sourceStatsCur === 'error' ? formatMessage({ id: 'dbi_feedback_date_must_be_in' }) : ''}
            >
              {/* <div
                className={classnames('dbi-public-truedata-feedback-uploadimg', {
                  'dbi-public-truedata-feedback-need-searchgame-en': isNeedSearchGame && locale !== LANGUAGE_CN,
                  'dbi-public-truedata-feedback-uploadimg-en': !isNeedSearchGame && locale !== LANGUAGE_CN,
                })}
              > */}
              <div className={'dbi-public-data-group-radio'}>
                <Radio.Group value={sourceValue} onChange={(value) => setSourceValue(value)}>
                  {FEEDBACKSOURCEOPTIONS.map((item: any) => {
                    return (
                      <Radio name={item.value} key={item.value}>
                        {item.text}
                      </Radio>
                    );
                  })}
                </Radio.Group>
              </div>
              {/* <Select
                  className="dbi-aigc-select"
                  appearance="button"
                  matchButtonWidth
                  options={FEEDBACKSOURCEOPTIONS}
                  value={sourceValue}
                  onChange={(value) => setSourceValue(value)}
                /> */}
              {/* </div> */}
            </Form.Item>
            <Form.Item
              label={''}
              status={linkStatsCur}
              message={linkStatsCur === 'error' ? formatMessage({ id: 'dbi_feedback_enter_correct_web_site' }) : ''}
            >
              {sourceValue === 'Expert Knowledge' && (
                <div className="EK-Tip" style={{ width: locale === LANGUAGE_CN ? '18%' : '31%' }}>
                  <Switch
                    style={{ marginRight: '10px' }}
                    value={anonymity}
                    onChange={(value) => {
                      setAnonymity(value);
                    }}
                  />
                  {formatMessage({ id: 'dbi_EK_Tip' })}
                </div>
              )}
              <Input
                value={linkValue}
                style={{
                  width:
                    locale === LANGUAGE_CN
                      ? sourceValue === 'Expert Knowledge'
                        ? '81%'
                        : '85%'
                      : sourceValue === 'Expert Knowledge'
                        ? '69%'
                        : '78%',
                }}
                placeholder={formatMessage({
                  id:
                    sourceValue === 'Expert Knowledge'
                      ? 'dbi_feedback_link_placeholder_EK'
                      : 'dbi_feedback_link_placeholder',
                })}
                onChange={(val) => handleInputLinkChange(val)}
              />
              {sourceValue !== 'Expert Knowledge' && (
                <ImagesUploaderCustomm
                  style={{ right: locale === LANGUAGE_CN ? '-6%' : '-1%' }}
                  ref={uploaderInstance}
                  // 上传模式为COS时，文件存储路径
                  cosPath="/images/feedback"
                  // 启用图片压缩时，预计最大接受的图片大小，单位为B，这里配置是6MB，上传的图片超过6MB时 会压缩图片
                  maxSize={6 * 1024 * 1024}
                  // 是否允许批量上传
                  multiple={true}
                  // 最多上传图片数量
                  max={8}
                  // 是否启用上传进度功能
                  enabledProgress={true}
                  // 是否启用图片压缩功能
                  enabledCompress={true}
                  // 图片压缩报错提示文案
                  compressErrorMsg={uploadImageErrorMsg}
                  // 图片上传网络报错提示文案
                  networkErrorMsg={uploadImageErrorMsg}
                  // 上传成功回调，通过该回调获取 图片数据
                  onUploadSuccess={(payload: IUploadSuccessPayload) => {
                    setImagesData(payload);
                  }}
                  // 删除成功回调
                  onDeleteSuccess={(payload: { path: string }) => {
                    const { path } = payload || {};
                    const imagesData = getImagesData();
                    const success = imagesData?.success?.filter((item) => item?.path !== path);
                    const error = imagesData?.error?.filter((item) => item?.path !== path);
                    const imagesDataTmp = {
                      success,
                      error,
                    };
                    setImagesData(imagesDataTmp);
                  }}
                  editImagesData={editImagesData}
                  handleDeleteEditImage={handleDeleteEditImage}
                  // 是否为添加真实反馈的图片上传组件
                  isPublicTrueData={true}
                />
              )}
            </Form.Item>
            <Form.Item label={formatMessage({ id: 'dbi_feedback_note' })}>
              <TextArea
                className="unloadModal-input"
                size="full"
                placeholder={formatMessage({ id: 'dbi_feedback_note_plc' })}
                // showCount
                maxLength={150}
                value={noteValue}
                onChange={(value) => {
                  setNoteValue(value);
                }}
              />
            </Form.Item>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button type="primary" onClick={() => submitFeedback()} disabled={confirmDisabledCur} loading={isLoading}>
            {formatMessage({ id: 'dbi_confirm' })}
          </Button>
          <Button type="weak" onClick={handleToggleModal}>
            {formatMessage({ id: 'dbi_cancel' })}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default React.forwardRef(PublicTrueData);
